/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import { createRoot } from 'react-dom/client';
import { addReactError } from '@datadog/browser-rum-react';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initHubspot } from './utils/initHubspot';
import { initHeap } from './utils/initHeap';
import { initGTM } from './utils/initGTM';
import { initDatadogRum } from './utils/initDatadogRum';

initHubspot();
initHeap();
initGTM();
initDatadogRum();

const container = document.getElementById('root');
const root = createRoot(container, {
    onUncaughtError: (error, errorInfo) => {
        addReactError(error, errorInfo);
    },
    onCaughtError: (error, errorInfo) => {
        addReactError(error, errorInfo);
    },
    onRecoverableError: (error, errorInfo) => {
        addReactError(error, errorInfo);
    },
});
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
